"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "auto": "auto",
  "name": "90",
  "date": "120",
  "amount": "140",
  "company": "180",
  "amountLong": "200",
  "startDate": "240",
  "longNumber": "280",
  "longContent32": "320",
  "longContent46": "460"
};
exports["default"] = _default;